function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';
import * as actievApi from '@/api/activityListApi';
import * as jumpApi from '@/api/jumpApi';
import throttle from '@/utils/throttle';
export default {
  components: {
    draggable: draggable
  },
  data: function data() {
    return {
      //  { type: 'input', isRequired: true, options: ['选项一','选项二'], defaultValue: 1, value: 0, formTitle: '电话号码' },
      TAG_OPTIONS: [{
        value: 'input',
        label: '单行文本'
      }, {
        value: 'textarea',
        label: '多行文本'
      }, {
        value: 'select',
        label: '下拉选择'
      }, {
        value: 'radio',
        label: '单选按钮'
      }, {
        value: 'checkbox',
        label: '多选按钮'
      }, {
        value: 'dateSelect',
        label: '日期'
      }, {
        value: 'phone',
        label: '电话号码'
      }, {
        value: 'tips',
        label: '说明文本'
      }],
      meatLists: [],
      redirectType: 1,
      // 默认返回上一页
      redirectUrl: '',
      // 指定跳转链接
      selectedLinkId: '',
      // 选中的链接ID
      linkList: [],
      // 链接列表
      loading: false // 加载状态
    };
  },
  props: {
    value: Array,
    initOption: Array,
    formConfig: {
      type: Object,
      default: function _default() {
        return {
          redirectType: 1,
          redirectUrl: ''
        };
      }
    }
  },
  watch: {
    value: {
      handler: function handler() {
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        this.meatLists = val.length ? val : [{
          selectProduct: [],
          selectNum: null,
          comboName: '',
          itemKey: actievApi.generateRandomString(10)
        }];
      },
      immediate: true,
      deep: true
    },
    initOption: {
      handler: function handler() {
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        this.meatLists = val.length ? val : [{
          selectProduct: [],
          selectNum: null,
          comboName: '',
          itemKey: actievApi.generateRandomString(10)
        }];
      },
      immediate: true,
      deep: true
    },
    formConfig: {
      handler: function handler() {
        var _this = this;
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (val) {
          this.redirectType = val.redirectType || 1;
          this.redirectUrl = val.redirectUrl || '';

          // 如果有redirectUrl，需要找到对应的链接ID
          if (val.redirectUrl && this.redirectType === 2) {
            // 先尝试从URL中提取ID
            var urlId = this.extractIdFromUrl(val.redirectUrl);
            if (urlId) {
              this.selectedLinkId = urlId;
            } else {
              // 如果无法从URL提取，则加载链接列表后查找匹配项
              this.getLinkList().then(function () {
                var link = _this.linkList.find(function (item) {
                  return item.url === val.redirectUrl || "".concat(item.url).concat(item.urlParam ? '?' + item.urlParam : '') === val.redirectUrl;
                });
                if (link) {
                  _this.selectedLinkId = link.id;
                }
              });
            }
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted: function mounted() {
    this.getLinkList();
  },
  methods: {
    throttle: throttle,
    changeVal: function changeVal() {
      this.$emit("input", this.meatLists);
    },
    getMealVal: function getMealVal() {
      return this.meatLists;
    },
    // 获取表单配置信息
    getFormConfig: function getFormConfig() {
      return {
        redirectType: this.redirectType,
        redirectUrl: this.selectedLinkId // 只存储链接ID
      };
    },
    removeMeat: function removeMeat(i) {
      this.meatLists.splice(i, 1);
    },
    addFormItem: function addFormItem() {
      this.meatLists.push({
        selectProduct: [],
        selectNum: null,
        itemKey: actievApi.generateRandomString(10)
      });
    },
    changeType: function changeType(type, i) {
      var info = JSON.parse(JSON.stringify(this.meatLists[i]));
      info = {
        type: type,
        itemKey: info.itemKey || actievApi.generateRandomString(10)
      };
      if (['select', 'radio', 'checkbox'].includes(type)) {
        info['options'] = [{
          name: ''
        }];
      }
      ;
      this.meatLists.splice(i, 1, info);
    },
    addOption: function addOption(i) {
      this.$set(this.meatLists[i], 'options', [].concat(_toConsumableArray(this.meatLists[i].options || []), [{
        name: ''
      }]));
    },
    removeOption: function removeOption(i, optIdx) {
      var currentoption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var option = JSON.parse(JSON.stringify(currentoption));
      option.splice(optIdx, 1);
      this.$set(this.meatLists[i], 'options', option);
    },
    // 获取链接列表
    getLinkList: function getLinkList() {
      var _this2 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.loading = true;
      return jumpApi.selectJumpUrl(keyword).then(function (res) {
        _this2.linkList = res || [];
        _this2.loading = false;
        return res;
      }).catch(function () {
        _this2.loading = false;
        return [];
      });
    },
    // 远程搜索方法
    remoteMethod: function remoteMethod(query) {
      var _this3 = this;
      this.throttle(function () {
        _this3.getLinkList(query);
      }, 300)();
    },
    // 处理链接选择变更
    handleLinkChange: function handleLinkChange(value) {
      this.selectedLinkId = value;
    },
    // 从URL中提取ID
    extractIdFromUrl: function extractIdFromUrl(url) {
      // 尝试直接解析数字ID
      if (/^\d+$/.test(url)) {
        return parseInt(url);
      }
      return null;
    }
  }
};